import app from 'flarum/forum/app';
import updateUser from './updateUser';

app.initializers.add('dvdfab/user', () => {
  updateUser();
});
